"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogBrowserLogsBeforeSend = void 0;
const types_1 = require("./types");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
/**
 * Common auto-mask for typical properties to mask for @datadog/browser-logs
 * `beforeSend` method; mutates and replaces properties contained within mask
 * list to `"REDACTED"` or custom `maskText`
 */
const datadogBrowserLogsBeforeSend = ({ mask = types_1.MASK_OPTIONS.DEFAULT, disableMask = false, whiteList = [], blackList = [], maskText = constants_1.MASK_WORD, maskNestedLevel = 0, } = {}) => {
    if (disableMask) {
        return () => true;
    }
    const formattedWhiteList = (0, utils_1.lowerCaseList)(whiteList);
    const formattedBlackList = (0, utils_1.lowerCaseList)(blackList);
    return (event) => {
        (0, utils_1.mutateMaskValues)({
            log: event,
            mask,
            whiteList: formattedWhiteList,
            blackList: formattedBlackList,
            maskText,
            maskNestedLevel,
        });
        return true;
    };
};
exports.datadogBrowserLogsBeforeSend = datadogBrowserLogsBeforeSend;
//# sourceMappingURL=datadog.js.map